import { render } from "./PedidoAguardandoAprovacao.vue?vue&type=template&id=e0f7ecd2&scoped=true"
import script from "./PedidoAguardandoAprovacao.vue?vue&type=script&lang=js"
export * from "./PedidoAguardandoAprovacao.vue?vue&type=script&lang=js"

import "./PedidoAguardandoAprovacao.vue?vue&type=style&index=0&id=e0f7ecd2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f7ecd2"]])

export default __exports__